<template>
    <div :class="`stockChange ${getCardClass}`">{{ dayChangeValue }}</div>
</template>

<script>
import StockHtmlHelper from './StockHtmlHelper';

export default {
    props: {
        change: {
            type: Number,
            default: 0
        },
        price: {
            type: Number,
            required: true,
            default: 0
        }
    },
    data() {
        return {
            stockHtmlHelper: null
        }
    },
    created() {
        this.stockHtmlHelper = new StockHtmlHelper();
    },
    computed: {
        getCardClass() {
            return this.change < 0 ? "down" : this.change > 0 ? 'up' : '';
        },
        dayChangeValue() {
            const symbol = this.change > 0 ? '+' : ''
            return `${symbol}${this.stockHtmlHelper.formatChange(this.change, this.price)}`
        }
    }
}
</script>

<style lang="scss" scoped>
.stockChange {
    font-weight: bold;
    &.up{
        color: var(--v-greenUp-base);
    }
    &.down{
        color: var(--v-redDown-base);
    }
}
</style>